import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Box,
  Container,
  Grid,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { AppColors } from "../../../util/AppColors";
import "../Vets/Vets.css";
import BathBays from "./cards/BathBays";
import Breeds from "./cards/Breeds";
import ConsultationRoom from "./cards/ConsultationRoom";
import Department from "./cards/Department";
import Devices from "./cards/Devices";
import Discount from "./cards/Discount";
import Group from "./cards/Group";
import Kennel from "./cards/Kennel";
import OperationTheatre from "./cards/OperationTheatre";
import PaymentMethod from "./cards/PaymentMethod";
import Products from "./cards/Products";
import Roles from "./cards/Roles";
import Schedule from "./cards/Schedule";
import Services from "./cards/Services";
import Speciality from "./cards/Speciality";
import Species from "./cards/Species";
import Vitals from "./cards/Vitals";

const navItems = [
  "Pets",
  "Vets",
  "Vitals",
  "Service/Products",
  "Access & Roles",
  "Facilities",
  "Billing",
];

const ComingSoon = () => {
  const [selectedTab, setSelectedTab] = useState("Pets");
  const [petAnchorEl, setPetAnchorEl] = useState(null);
  const [vetAnchorEl, setVetAnchorEl] = useState(null);
  const [serviceAnchorEl, setServiceAnchorEl] = useState(null);
  const [billingAnchorEl, setBillingAnchorEl] = useState(null); // ✅ new anchor
  const [vitalsAnchorEl, setVitalsAnchorEl] = useState(null);
  const [vitalsSubTab, setVitalsSubTab] = useState("Vitals");

  const [petSubTab, setPetSubTab] = useState("Species");
  const [vetSubTab, setVetSubTab] = useState("Roles");
  const [serviceSubTab, setServiceSubTab] = useState("Services");
  const [billingSubTab, setBillingSubTab] = useState("PaymentMethod"); // ✅ new subtab
  const [facilitiesAnchorEl, setFacilitiesAnchorEl] = useState(null);
  const [facilitiesSubTab, setFacilitiesSubTab] = useState("ConsultationRoom");
  const [speciesSelected, setSpeciesSelected] = useState(false); // 👈 add this at top
  const [selectedSpeciesId, setSelectedSpeciesId] = useState(null); // 👈
  const [groupSelected, setGroupSelected] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);

  return (
    <>
      {/* Top Navigation Bar */}
      <div
        className="flex-row"
        style={{ padding: "12px 24px", backgroundColor: AppColors.primary }}
      >
        {navItems.map((item, index) => (
          <div key={index} className="ph10pv3">
            {item === "Pets" ? (
              <div
                onClick={() => {
                  setSelectedTab("Pets");
                  setPetSubTab("Species"); // always go to Species
                }}
                className={`flex-center cursor ${
                  selectedTab === "Pets"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Pets
              </div>
            ) : item === "Vets" ? (
              <>
                <div
                  onMouseEnter={(e) => {
                    setVetAnchorEl(e.currentTarget);
                  }}
                  className={`flex-center cursor ${
                    selectedTab === "Vets"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Vets <ArrowDropDownIcon fontSize="small" />
                </div>
                <Menu
                  anchorEl={vetAnchorEl}
                  open={Boolean(vetAnchorEl)}
                  onClose={() => setVetAnchorEl(null)}
                  MenuListProps={{
                    onMouseLeave: () => setVetAnchorEl(null),
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setVetSubTab("Roles");
                      setSelectedTab("Vets");
                      setVetAnchorEl(null);
                    }}
                  >
                    Roles
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setVetSubTab("Department");
                      setSelectedTab("Vets");
                      setVetAnchorEl(null);
                    }}
                  >
                    Department
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setVetSubTab("Speciality");
                      setSelectedTab("Vets");
                      setVetAnchorEl(null);
                    }}
                  >
                    Speciality
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setVetSubTab("Schedule");
                      setSelectedTab("Vets");
                      setVetAnchorEl(null);
                    }}
                  >
                    Schedule
                  </MenuItem>
                </Menu>
              </>
            ) : item === "Vitals" ? (
              <div
                onClick={() => {
                  setSelectedTab("Vitals");
                  setVitalsSubTab("Group"); // directly go to Group
                }}
                className={`flex-center cursor ${
                  selectedTab === "Vitals"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Vitals
              </div>
            ) : item === "Facilities" ? (
              <>
                <div
                  onMouseEnter={(e) => {
                    // setSelectedTab("Facilities");
                    setFacilitiesAnchorEl(e.currentTarget);
                  }}
                  className={`flex-center cursor ${
                    selectedTab === "Facilities"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Facilities <ArrowDropDownIcon fontSize="small" />
                </div>
                <Menu
                  anchorEl={facilitiesAnchorEl}
                  open={Boolean(facilitiesAnchorEl)}
                  onClose={() => setFacilitiesAnchorEl(null)}
                  MenuListProps={{
                    onMouseLeave: () => setFacilitiesAnchorEl(null),
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setFacilitiesSubTab("ConsultationRoom");
                      setSelectedTab("Facilities");
                      setFacilitiesAnchorEl(null);
                    }}
                  >
                    Consultation Room
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      setFacilitiesSubTab("OperationTheatre");
                      setSelectedTab("Facilities");
                      setFacilitiesAnchorEl(null);
                    }}
                  >
                    Operation Theatre
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      setFacilitiesSubTab("Kennel");
                      setSelectedTab("Facilities");
                      setFacilitiesAnchorEl(null);
                    }}
                  >
                    Kennel
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      setFacilitiesSubTab("Devices");
                      setSelectedTab("Facilities");
                      setFacilitiesAnchorEl(null);
                    }}
                  >
                    Devices
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      setFacilitiesSubTab("BathBays");
                      setSelectedTab("Facilities");
                      setFacilitiesAnchorEl(null);
                    }}
                  >
                    Bath Bays
                  </MenuItem>
                </Menu>
              </>
            ) : item === "Service/Products" ? (
              <>
                <div
                  onMouseEnter={(e) => {
                    // setSelectedTab("Service/Products");
                    setServiceAnchorEl(e.currentTarget);
                  }}
                  className={`flex-center cursor ${
                    selectedTab === "Service/Products"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Service/Products <ArrowDropDownIcon fontSize="small" />
                </div>
                <Menu
                  anchorEl={serviceAnchorEl}
                  open={Boolean(serviceAnchorEl)}
                  onClose={() => setServiceAnchorEl(null)}
                  MenuListProps={{
                    onMouseLeave: () => setServiceAnchorEl(null),
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setServiceSubTab("Services");
                      setSelectedTab("Service/Products");
                      setServiceAnchorEl(null);
                    }}
                  >
                    Services
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      setServiceSubTab("Products");
                      setSelectedTab("Service/Products");
                      setServiceAnchorEl(null);
                    }}
                  >
                    Products
                  </MenuItem>
                </Menu>
              </>
            ) : item === "Billing" ? (
              <>
                <div
                  onMouseEnter={(e) => {
                    // setSelectedTab("Billing");
                    setBillingAnchorEl(e.currentTarget);
                  }}
                  className={`flex-center cursor ${
                    selectedTab === "Billing"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Billing <ArrowDropDownIcon fontSize="small" />
                </div>
                <Menu
                  anchorEl={billingAnchorEl}
                  open={Boolean(billingAnchorEl)}
                  onClose={() => setBillingAnchorEl(null)}
                  MenuListProps={{
                    onMouseLeave: () => setBillingAnchorEl(null),
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setBillingSubTab("Payment Method");
                      setSelectedTab("Billing");
                      setBillingAnchorEl(null);
                    }}
                  >
                    Payment Method
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      setBillingSubTab("Discount");
                      setSelectedTab("Billing");
                      setBillingAnchorEl(null);
                    }}
                  >
                    Discount
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <div
                onClick={() => setSelectedTab(item)}
                className={`flex-center cursor ${
                  selectedTab === item
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                {item}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Main Section */}
      {/* {selectedTab === "Pets" ? (
        <Box sx={{ padding: "20px" }}>
          {petSubTab === "Species" ? <Species /> : <Breeds />}
        </Box>
      )  */}
      {selectedTab === "Pets" ? (
        <Box sx={{ padding: "20px" }}>
          {speciesSelected ? (
            <Breeds
              speciesId={selectedSpeciesId}
              onBack={() => setSpeciesSelected(false)}
            />
          ) : (
            <Species
              onSpeciesClick={(id) => {
                setSelectedSpeciesId(id);
                setSpeciesSelected(true);
              }}
            />
          )}
        </Box>
      ) : selectedTab === "Vets" ? (
        <Box sx={{ padding: "20px" }}>
          {vetSubTab === "Roles" && <Roles />}
          {vetSubTab === "Department" && <Department />}
          {vetSubTab === "Speciality" && <Speciality />}
          {vetSubTab === "Schedule" && <Schedule />}
        </Box>
      ) : selectedTab === "Vitals" ? (
        <Box sx={{ padding: "20px" }}>
          {groupSelected ? (
            <Vitals
              groupId={selectedGroupId}
              onBack={() => {
                setGroupSelected(false);
                setSelectedGroupId(null);
              }}
            />
          ) : (
            <Group
              onGroupClick={(id) => {
                setSelectedGroupId(id);
                setGroupSelected(true);
              }}
            />
          )}
        </Box>
      ) : selectedTab === "Service/Products" ? (
        <Box sx={{ padding: "20px" }}>
          {serviceSubTab === "Services" ? <Services /> : <Products />}
        </Box>
      ) : selectedTab === "Facilities" ? (
        <Box sx={{ padding: "20px" }}>
          {facilitiesSubTab === "ConsultationRoom" && <ConsultationRoom />}
          {facilitiesSubTab === "OperationTheatre" && <OperationTheatre />}
          {facilitiesSubTab === "Kennel" && <Kennel />}
          {facilitiesSubTab === "Devices" && <Devices />}
          {facilitiesSubTab === "BathBays" && <BathBays />}
        </Box>
      ) : selectedTab === "Billing" ? (
        <Box sx={{ padding: "20px" }}>
          {billingSubTab === "Payment Method" ? (
            <PaymentMethod />
          ) : (
            <Discount />
          )}
        </Box>
      ) : (
        <Container
          style={{
            height: "calc(100vh - 64px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid container alignItems="center" justifyContent="center">
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              <Typography variant="h4" align="center" color="textSecondary">
                Coming Soon...
              </Typography>
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  );
};

export default ComingSoon;
